import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Moon, Sun, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/hooks/useTheme";

const links = [
  { to: "/", label: "Inicio" },
  { to: "/informacion", label: "Información importante" },
  { to: "/medidor", label: "Medidor de velocidad" },
  { to: "/transparencia", label: "Transparencia" },
  { to: "/contacto", label: "Contacto" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const { theme, toggle } = useTheme();
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/70 border-b border-border/60" data-testid="navbar">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-[72px] items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="navbar-logo">
            <img src="/logo.png" alt="Colnexx" className="h-11 w-11 object-contain" />
            <span className="font-display text-2xl font-black tracking-tight hidden sm:block">COLNEXX</span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.split(" ")[0].toLowerCase()}`}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-full text-sm font-medium transition-colors ${
                    isActive ? "text-primary bg-accent" : "text-muted-foreground hover:text-foreground hover:bg-muted"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              onClick={toggle}
              aria-label="Cambiar tema"
              data-testid="theme-toggle"
              className="h-10 w-10 grid place-items-center rounded-full hover:bg-muted transition-colors"
            >
              {theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </button>
            <Link to="/pqr" className="hidden sm:block">
              <Button className="rounded-full font-semibold gap-2" data-testid="navbar-pqr-btn">
                <Zap className="h-4 w-4" /> Radicar PQR
              </Button>
            </Link>
            <button
              className="lg:hidden h-10 w-10 grid place-items-center rounded-full hover:bg-muted"
              onClick={() => setOpen((o) => !o)}
              aria-label="Menú"
              data-testid="mobile-menu-toggle"
            >
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border/60 bg-background px-4 py-4 space-y-1" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-xl text-base font-medium ${isActive ? "text-primary bg-accent" : "hover:bg-muted"}`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/pqr" onClick={() => setOpen(false)}>
            <Button className="w-full rounded-full font-semibold mt-2">Radicar PQR</Button>
          </Link>
        </div>
      )}
    </header>
  );
}
